import React from 'react';
import InventoryDrsDetails from './InventoryDrsDetails';

export default function InventoryResourceDetails({ resource }) {
  const attributes = resource.resource?.attributes;
  const isDrs = resource.resource_type === 'Disaster Recovery (DRS)';
  return (
    <div className="p-4 space-y-4 bg-violet-500/[0.04]">
      <p className="text-xs text-violet-200/70">
        Datos de la captura histórica, no una consulta en vivo. Se muestran atributos permitidos;
        los campos ausentes no confirman que el recurso carezca de esa configuración.
      </p>
      {isDrs && <p className="text-xs text-violet-200/70">
        Servidor protegido por AWS Elastic Disaster Recovery, no una EC2 adicional.
        La replicación y las pruebas corresponden a esta captura; no garantizan la recuperabilidad actual.
      </p>}
      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {[
          ['ID del recurso', resource.resource_id], ['Nombre', resource.resource_name],
          ['Tipo', resource.resource_type], ['Región', resource.region], ['Servicio', resource.service],
        ].map(([label, value]) => (
          <div key={label}>
            <dt className="text-xs text-white/50 mb-1">{label}</dt>
            <dd className="text-sm break-all text-white/90">{value ?? 'No informado en la captura'}</dd>
          </div>
        ))}
      </dl>
      {!attributes ? (
        <p className="text-xs text-white/60">Se requiere el backend actualizado para consultar los atributos del recurso.</p>
      ) : !Object.keys(attributes).length ? (
        <p className="text-xs text-white/60">La captura no contiene atributos adicionales permitidos para esta ficha.</p>
      ) : isDrs ? <InventoryDrsDetails attributes={attributes} /> : (
        <dl className="space-y-3">
          {Object.entries(attributes).map(([key, value]) => (
            <div key={key}>
              <dt className="text-xs text-violet-200 mb-1">{key}</dt>
              <dd className="text-xs whitespace-pre-wrap break-all text-white/90">
                {value === null ? 'No informado en la captura'
                  : typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value)}
              </dd>
            </div>
          ))}
        </dl>
      )}
      {resource.resource?.truncated && (
        <p role="status" className="text-xs text-amber-200">Detalle limitado por tamaño; no representa la configuración completa.</p>
      )}
    </div>
  );
}
